import { FC } from 'react';
import { ChakraConfirmationDialog } from 'app/components/Dialogs';
import {
  Contribution,
  ContributionClassName,
  ContributionsListItem,
} from 'types/contribution';

export interface DeleteSongContributionDialogProps {
  onClose: () => void;
  onConfirm: (contributions: Partial<Contribution>[]) => void;
  contributionsClassName?: ContributionClassName;
  contributor?: ContributionsListItem;
  open: boolean;
  affectsSplit?: boolean;
}

export const DeleteSongContributorDialog: FC<DeleteSongContributionDialogProps> = ({
  onClose,
  onConfirm,
  contributionsClassName,
  contributor,
  open,
  affectsSplit,
}) => {
  const handleContributorDelete = () => {
    onClose();
    if (contributor?.contributions) {
      onConfirm(contributor.contributions);
    }
  };
  const name = contributor?.profile?.displayName;
  const firstLetter = contributionsClassName?.length
    ? contributionsClassName[0]
    : '';

  return (
    <ChakraConfirmationDialog
      title="Remove Contributor"
      message={`Are you sure you want to remove ${name} as ${
        firstLetter.match(/[aeiou]/i) ? 'an' : 'a'
      } ${contributionsClassName} contributor? This will also delete their ${contributionsClassName} credits${
        affectsSplit ? ' and may affect an existing split' : ''
      }. `}
      actionButtonText="Remove"
      isOpen={open}
      handleAction={handleContributorDelete}
      onClose={onClose}
    />
  );
};
